import { render, staticRenderFns } from "./MdMemo.vue?vue&type=template&id=8cc20512&scoped=true&"
import script from "./MdMemo.vue?vue&type=script&lang=js&"
export * from "./MdMemo.vue?vue&type=script&lang=js&"
import style0 from "./MdMemo.vue?vue&type=style&index=0&id=8cc20512&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cc20512",
  null
  
)

export default component.exports